export default __webpack_public_path__ + "static/media/cumulative_image.bec1394f.png";